import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f559b9a4&scoped=true&"
import script from "./index.vue?vue&type=script&scoped=true&lang=js&"
export * from "./index.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f559b9a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f559b9a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f559b9a4')) {
      api.createRecord('f559b9a4', component.options)
    } else {
      api.reload('f559b9a4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f559b9a4&scoped=true&", function () {
      api.rerender('f559b9a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/albumSelect/index.vue"
export default component.exports